export default function Footer() {
    return (
        <footer className='text-center py-4'
            style={{ background: '#D4E9F7' }}
        >
            <div className="my-3">
                <a href="https://www.producthunt.com/posts/menudr?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-menudr" target="_blank">
                    <img
                        src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=327061&theme=dark"
                        alt="MenuDR - easy professional digital menu. | Product Hunt"
                        style={{ width: '250px', height: '54px' }} width="250" height="54" /></a>
            </div>
            <div>
                <p>
                    Copyright  ©Menu DR 2022. <br /> Hecho con amor desde Republica Dominicana ❤
                </p>
            </div>
            <a href="/">
                Inicio
            </a>
            {" | "}
            <a href="https://wa.me/8095226730" target={"_blank"}>Precios</a>
            <div className="mt-2">
                <b>
                    <a
                        href="https://www.linkedin.com/in/robertfrontend/"
                        target={"_blank"}
                        className="text-dark"
                    >By: Robertfrontend</a>
                </b>
            </div>
        </footer>
    )
}

